import { Box, ButtonBase, Divider, Modal, Stack, Typography } from "@mui/material";
import Iconify from "../../components/Iconify";
import FlexBetween from "../../components/flexbox/FlexBetween";

export default function AppModal({ keepMounted, open, onClose, children, title, width, disableBackground, toggleTutorial, closeBtnSx, sx }) {
    return <Modal keepMounted={keepMounted} open={Boolean(open)} onClose={onClose} sx={{
        marginTop: "10px",
        zIndex: 107, '& .MuiBackdrop-root': { background: "rgba(0,0,0,0.8)" }, '& *:not(.tutorial-trigger)': toggleTutorial ? {
            pointerEvents: 'none'
        } : null,
        ...sx
    }}>
        <Stack p={1} sx={{ height: '100vh', width: width || '100%', margin: "auto" }} justifyContent={'center'} alignItems={'center'}>
            <Stack width={'100%'} px={2} py={1} minHeight={200} sx={{ position: "relative", border: '1px dashed #89ec5d', background: 'rgba(0,0,0,0.7)' }}>
                <FlexBetween sx={{ borderBottom: "1px dashed #89ec5d" }}>
                    {
                        title && <Typography variant="h5" sx={{ zIndex: 1, pb: '5px', textAlign: 'center', lineHeight: '35px', backgroundSize: 'contain' }}>{title}</Typography>
                    }
                    <Box flexGrow={1} />
                    <ButtonBase onClick={onClose} sx={{ zIndex: toggleTutorial ? 0 : 100, width: 40, height: 40, marginRight: '-15px', ...closeBtnSx }}>
                        <Iconify icon={'ic:twotone-close'} size={20} sx={{ color: '#fff' }} />
                    </ButtonBase>
                </FlexBetween>
                <Stack zIndex={1} py={1}>
                    {
                        children
                    }
                </Stack>
            </Stack>
        </Stack>
    </Modal>
}